import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasExt',
  standalone: true
})
export class HasExtPipe implements PipeTransform {
  transform(url?: string, ext?: string): boolean {
    if (!url || !ext) return false;
    const urlExt = url.split('.').pop()?.toLowerCase();
    if (!urlExt) return false;

    return urlExt === ext.toLowerCase();
  }
}
